module.exports = __webpack_public_path__ + "static/img/left-home-row-5.75e2047f.webp";